import BaseService from "../../BaseService";

export default class GPZVVEinladungService extends BaseService {

  constructor(prefix, id) {
    super(`${prefix}/${id}/zvv/einladung`);
  }
}
